import { TranslatedText } from '@staccx/i18n'
import { Select } from './Select'
import { useUserContext } from '../../../../../context/UserProvider'

export const ConsolidateInvoiceSelect = ({ className }: { className?: string }) => {
  //@ts-ignore
  const { consolidateInvoice, handleSetConsolidateInvoice, chosenCompany } = useUserContext()
  if (!chosenCompany) return null

  const consolidatedAgreements = [
    { value: '_ALL_', label: <TranslatedText i18nKey="ALL" /> },
    ...chosenCompany.consolidateAgreement.map((item) => ({
      value: item.ConsolidateCode,
      label: `${item.ConsolidateCode} - ${item.ConsolidateDescription}`,
    })),
  ]

  return (
    <Select
      className={`${className} h-11 min-w-56`}
      placeholder="Velg konsolidert avtale"
      options={consolidatedAgreements}
      onChange={(selectedItem) => handleSetConsolidateInvoice({ ConsolidateCode: selectedItem })}
      value={consolidateInvoice?.ConsolidateCode}
    />
  )
}
